<template>
  <template v-if="field !== null && field !== undefined && isIgnored !== true">
    <div class="jb-field" :id="id + 'FieldWrapper'">
      <template v-if="field.type === 'textinput'">
        <label :for="id" class="jb-label">{{ field.label }}</label>
        <input class="jb-input jb-input--text" type="text" :name="id" :id="id"
               v-on:input="updateValue($event.target.value)"
               :value="modelValue" :placeholder="field.placeholder"/>
      </template>
      <template v-if="field.type === 'select' && Array.isArray(field.values)">
        <label :for="id" class="jb-label">{{ field.label }}</label>
        <template v-if="field.multiple">
          <select class="jb-input jb-input--select" :name="id" :id="id"
                  v-on:input="updateValue($event.target.value)"
                  :value="modelValue" multiple>
            <option value="" v-if="showAllDefault">
              <template v-if="field.placeholder">{{ field.placeholder }}</template>
              <template v-else>All</template>
            </option>
            <template v-for="value in field.values" v-bind:key="value">
              <option :value="value" v-if="value !== '' && value !== undefined && value !== null">
                {{ formattedValue(value) }}
              </option>
            </template>
          </select>
        </template>
        <template v-else>
          <select class="jb-input jb-input--select" :name="id" :id="id"
                  v-on:input="updateValue($event.target.value)"
                  :value="modelValue">
            <option value="" v-if="showAllDefault">
              <template v-if="field.placeholder">{{ field.placeholder }}</template>
              <template v-else>All</template>
            </option>
            <template v-for="value in field.values" v-bind:key="value">
              <option :value="value" v-if="value !== '' && value !== undefined && value !== null">
                {{ formattedValue(value) }}
              </option>
            </template>
          </select>
        </template>
      </template>
      <template v-if="field.type === 'checkboxset' && Array.isArray(field.values)">
        <p class="jb-label">{{ field.label }}</p>
        <div class="jb-checkbox-wrapper" v-for="(value, index) in field.values" v-bind:key="value"
             :ref="'checkboxes' + id">
          <template v-if="value !== ''">
            <!--                        todo deal with not multiple clearing other checkboxes-->
            <input
                class="form-check-input"
                type="checkbox"
                :value="value"
                :name="id + '[]'"
                :id="id + index"
                v-model="checkboxValues"
                v-on:change="updateCheckboxValue()"
            >
            <label class="form-check-label" :for="id + index">
              {{ formattedValue(value) }}
            </label>
          </template>
        </div>
      </template>
      <template v-if="field.type === 'slider'">
        <div class="jb-slider-field-wrapper">
          <div class="jb-slider-dropdown-wrapper">
            <label :for="id + 'Unit'" class="jb-label">{{ field.label }}</label>
            <select class="jb-input jb-input--select" :name="id + 'Unit'" :id="id + 'Unit'"
                    v-on:input="updateSliderUnit($event.target.value)"
                    :value="sliderUnit">
              <option :value="'all'" v-bind:key="'all'">
                All
              </option>
              <option v-for="value in field.values" :value="value.unit" v-bind:key="value.unit">
                {{ value.label }}
              </option>
            </select>
          </div>
          <div class="jb-slider-slider-wrapper" :style="sliderStylesObject">
            <label class="jb-label">{{ field.label }} Range ({{ sliderMinCaption }} to {{ sliderMaxCaption }})</label>
            <MultiRangeSlider
                :key="this.sliderUnit"
                :min="sliderMin"
                :max="sliderMax"
                :step="sliderStep"
                :rangeMargin="sliderStep"
                :ruler="false"
                :label="false"
                :minValue="sliderMinValue"
                :min-caption="sliderMinCaption"
                :maxValue="sliderMaxValue"
                :max-caption="sliderMaxCaption"
                @input="updateSliderValues"
            />
            <div class="jb-slider-labels">
              <div class="jb-slider-label jb-slider-label--min">
                {{ sliderMinLabel }}
              </div>
              <div class="jb-slider-label jb-slider-label--max">
                {{ sliderMaxLabel }}
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-if="field.type === 'dependent'">
        <div class="mb-3">
          <p v-if="field.label" class="jb-label mb-3">{{ field.label }}</p>
          <p class="jb-label">{{ this.dependentFieldLabels[0] }}</p>
          <select class="jb-input jb-input--select" :name="dependentFieldNames[0]" :id="dependentFieldNames[0]"
                  v-on:input="updateDependentField1Value($event.target.value)"
                  :value="dependentField1Value">
            <option value="">
              <template v-if="field.placeholder">{{ field.placeholder }}</template>
            </option>
            <option v-for="value in dependentField1Values" :value="value" v-bind:key="value">
              {{ value }}
            </option>
          </select>
        </div>
        <template v-if="dependentField1Value !== '' && dependentField2Values !== []">
          <p class="jb-label">{{ dependentFieldLabels[1] }}</p>
          <select class="jb-input jb-input--select" :name="dependentFieldNames[1]" :id="dependentFieldNames[1]"
                  v-on:input="updateDependentField2Value($event.target.value)"
                  :value="dependentField2Value">
            <option value="">
              <template v-if="field.placeholder">{{ field.placeholder }}</template>
            </option>
            <option v-for="value in dependentField2Values" :value="value" v-bind:key="value">
              {{ value }}
            </option>
          </select>
        </template>
      </template>
    </div>
  </template>
</template>

<script>

import MultiRangeSlider from "multi-range-slider-vue";

export default {
  name: 'FilterInput',
  components: {
    MultiRangeSlider
  },
  props: {
    modelValue: {
      required: true
    },
    field: {
      type: Object,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
    showAllDefault: {
      type: Boolean,
      required: false,
      default: true
    },
    ignoredFilters: {
      type: Array,
      required: false,
      default() {
        return [];
      }
    },
  },
  data() {
    return {
      checkboxValues: [],
      sliderUnit: 'all',
      sliderMin: 0,
      sliderMax: 1,
      sliderStep: 1,
      sliderMinValue: 0,
      sliderMaxValue: 1,
      valueFormat: '',
      dependentFieldLabels: [],
      dependentFieldNames: [],
      dependentFieldAllValues: [],
      dependentField1Values: [],
      dependentField1Value: '',
      dependentField2Values: [],
      dependentField2Value: '',
    }
  },
  emits: ['update:modelValue'],
  computed: {
    isIgnored() {
      return this.ignoredFilters.includes(this.id)
    },
    sliderMinCaption() {
      return this.formatSliderRateString(this.sliderMinValue);
    },
    sliderMinLabel() {
      return this.formatSliderRateString(this.sliderMin);
    },
    sliderMaxCaption() {
      return this.formatSliderRateString(this.sliderMaxValue);
    },
    sliderMaxLabel() {
      return this.formatSliderRateString(this.sliderMax);
    },
    sliderOutputJson() {
      if (this.sliderUnit === 'all') {
        return {
          unit: this.sliderUnit,
          min: undefined,
          max: undefined,
        }
      } else {
        return {
          unit: this.sliderUnit,
          min: this.sliderMinValue,
          max: this.sliderMaxValue,
        }
      }
    },
    sliderStylesObject() {
      if (this.sliderUnit === 'all') {
        return {
          display: 'none'
        }
      } else {
        return {};
      }
    },
  },
  methods: {
    updateValue(value) {
      this.$emit('update:modelValue', value);
    },
    updateCheckboxValue() {
      this.$emit('update:modelValue', this.checkboxValues);
    },
    updateSliderValues(e) {
      this.sliderMinValue = e.minValue;
      this.sliderMaxValue = e.maxValue;
      this.$emit('update:modelValue', this.sliderOutputJson);
    },
    updateDependentField1Value(value) {
      this.dependentField1Value = value;
      if (this.dependentField1Value === '') {
        this.dependentField2Values = [];
      } else {
        let values = this.dependentFieldAllValues;
        this.dependentField2Values = values[this.dependentField1Value];
      }
      this.dependentField2Value = '';
      this.updateBothDependantFieldValues();
    },
    updateDependentField2Value(value) {
      this.dependentField2Value = value;
      this.updateBothDependantFieldValues();
    },
    updateBothDependantFieldValues() {
      let fieldValueData = {};
      fieldValueData[this.field.values.fieldnames[0]] = this.dependentField1Value;
      fieldValueData[this.field.values.fieldnames[1]] = this.dependentField2Value;
      this.$emit('update:modelValue', fieldValueData);
    },
    clearData() {
      if (this.field.type === 'checkboxset') {
        this.checkboxValues = [];
      }
      if (this.field.type === 'slider') {
        this.setSliderDataForAll();
      }
      if (this.field.type === 'dependent') {
        this.updateDependentField1Value('');
      }
    },
    updateSliderUnit(unit) {
      if (unit === 'all') {
        this.setSliderDataForAll();
      } else {
        let unitValue = this.field.values.filter(obj => {
          return obj.unit === unit;
        })[0];

        this.sliderMin = parseFloat(unitValue.min);
        this.sliderMax = parseFloat(unitValue.max);
        this.sliderStep = parseInt(unitValue.step);
        this.sliderMinValue = parseFloat(unitValue.min);
        this.sliderMaxValue = parseFloat(unitValue.max);
        this.valueFormat = unitValue.valueFormat;
        this.sliderUnit = unitValue.unit;
      }
      this.$emit('update:modelValue', this.sliderOutputJson);
    },
    formatSliderRateString(rate) {
      let formattedRate = new Intl.NumberFormat('en-US', {
        maximumFractionDigits: 1,
        notation: "compact",
        compactDisplay: "short"
      }).format(rate);
      return this.valueFormat.split('${rate}').join(formattedRate)
    },
    setSliderDataForAll() {
      this.sliderMin = 0;
      this.sliderMax = 1;
      this.sliderStep = 1;
      this.sliderMinValue = 0;
      this.sliderMaxValue = 1;
      this.valueFormat = '';
      this.sliderUnit = 'all';
    },
    formattedValue(value) {
      let labeltexttransform = this.field.labeltexttransform;

      if (labeltexttransform === undefined || labeltexttransform === null || labeltexttransform === '') {
        return value;
      }

      let functions = labeltexttransform.split('.');

      if (functions.length < 1) {
        return value;
      }

      let newValue = value;

      for (let i = 0; i < functions.length; i++) {

        let functionString = functions[i];
        let splitString = functionString.split('(');
        let functionName = splitString[0];
        let functionParameters = splitString[1].slice(0,-1);

        let functionParametersSplit = functionParameters.split(',');

        if (functionName === 'replace') {
          newValue = newValue.replace(functionParametersSplit[0], functionParametersSplit[1]);
        }

        if (functionName === 'titleCase') {
          newValue = newValue.toLowerCase().split(' ').map(function(word) {
            return (word.charAt(0).toUpperCase() + word.slice(1));
          }).join(' ');
        }

      }

      return newValue;
    }
  },
  mounted() {
    if (this.field.type === 'checkboxset') {
      this.checkboxValues = this.modelValue;
    }
    if (this.field.type === 'slider') {
      if (
          this.modelValue['unit'] !== undefined &&
          this.modelValue['min'] !== undefined &&
          this.modelValue['max'] !== undefined &&
          this.modelValue['unit'] !== '' &&
          this.modelValue['min'] !== '' &&
          this.modelValue['max'] !== ''
      ) {
        this.updateSliderUnit(this.modelValue['unit']);
        this.sliderMinValue = parseFloat(this.modelValue['min']);
        this.sliderMaxValue = parseFloat(this.modelValue['max']);
      } else {
        this.setSliderDataForAll();
      }
    }

    if (this.field.type === 'dependent') {
      this.dependentFieldLabels = this.field.values.fieldlabels;
      this.dependentFieldNames = this.field.values.fieldnames;
      this.dependentFieldAllValues = this.field.values.values;
      this.dependentField1Values = Object.keys(this.field.values.values);

      if (
          this.modelValue[this.field.values.fieldnames[0]] !== undefined &&
          this.modelValue[this.field.values.fieldnames[0]] !== ''
      ) {
        this.dependentField1Value = this.modelValue[this.field.values.fieldnames[0]];
        this.dependentField2Values = this.dependentFieldAllValues[this.dependentField1Value];
      } else {
        this.dependentField1Value = '';
      }

      if (
          this.modelValue[this.field.values.fieldnames[1]] !== undefined &&
          this.modelValue[this.field.values.fieldnames[1]] !== ''
      ) {
        this.dependentField2Value = this.modelValue[this.field.values.fieldnames[1]];
      } else {
        this.dependentField2Value = '';
      }
    }
  },
}
</script>

<style>

.multi-range-slider {

  border: none;
  box-shadow: none;

}

.multi-range-slider .bar-left, .multi-range-slider .bar-inner, .multi-range-slider .bar-right {

  box-shadow: none;

}

.multi-range-slider .bar-left {

  padding: 2px 0;

}

.multi-range-slider .bar-inner {

  background-color: #06a2ff;
  border-color: #06a2ff

}

.multi-range-slider .thumb:before {

  box-shadow: none;
  border-color: #06a2ff;
  background-color: #06a2ff;

}

.multi-range-slider .thumb .caption * {

  background-color: #ffffff;
  color: #212529;
  border: 1px solid #06a2ff;

}

.jb-slider-slider-wrapper {

  padding-top: 1rem;

}

.jb-slider-labels {

  display: flex;

}

.jb-slider-label {

  flex: 0 0 50%;

}

.jb-slider-label--min {

  text-align: left;

}

.jb-slider-label--max {

  text-align: right;

}

</style>
